let echoPromise = null;

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
}

export async function ensureEcho() {
  if (window.Echo) {
    return window.Echo;
  }

  if (!echoPromise) {
    echoPromise = (async () => {
      const { default: Echo } = await import('laravel-echo');
      const { default: Pusher } = await import('pusher-js');
      window.Pusher = Pusher;
    //   Pusher.logToConsole = true;
      window.Echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
        forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        activityTimeout: 20000,
        pongTimeout: 10000,
        auth: {
          headers: {
            'X-CSRF-TOKEN': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      });
      return window.Echo;
    })();
  }

  return echoPromise;
}
